import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_PAIRING_STATUS } from '../get-pairing-status';
import { stopPairingStatusAPI } from './api';

export function useStopPairing(user) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    () => stopPairingStatusAPI(user?.Id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_PAIRING_STATUS, tenantId, user?.Account?.Email]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'pairingProcessStopped',
          },
        });
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}

